import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {staticUrl} from "@khan/urls";

import * as mediaQueries from "./media-queries.ts";
import {
    SerifHeadingDistrictsTitle,
    SerifStat,
} from "./typography/typography.ts";

export type Props = {
    kind: "Infographic";
    headline: string;
    staticGraphic: string;
    // the possible values of the imageStyles property should match styles at
    // the bottom of this file
    imageStyles: "bringEducation";
    stats: Array<string | React.ReactElement>;
};

export default class Infographic extends React.Component<Props> {
    render(): React.ReactNode {
        const {headline, staticGraphic, imageStyles, stats} = this.props;

        return (
            <View style={styles.container}>
                <SerifHeadingDistrictsTitle tag="h2" style={styles.headline}>
                    {headline}
                </SerifHeadingDistrictsTitle>
                <View style={styles.content}>
                    <View style={styles.imgContainer}>
                        <img
                            alt=""
                            src={staticUrl(staticGraphic)}
                            className={css(styles[imageStyles])}
                        />
                    </View>
                    <View style={styles.statList}>
                        {stats.map((stat, i) => (
                            <SerifStat style={styles.stat} key={i}>
                                {stat}
                            </SerifStat>
                        ))}
                    </View>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        maxWidth: 1200,
        padding: "0 64px",
        margin: "0 auto 160px auto",

        [mediaQueries.smallDesktopOrSmaller]: {
            maxWidth: "inherit",
            paddingLeft: 20,
            paddingRight: 20,
        },

        [mediaQueries.largePhoneOrSmaller]: {
            marginBottom: 130,
        },
    },
    headline: {
        marginTop: 54,
        marginBottom: 80,
        textAlign: "center",
        maxWidth: 620,

        [mediaQueries.smallDesktopOrSmaller]: {
            marginTop: 120,
            marginBottom: 120,
        },

        [mediaQueries.smallTabletOrSmaller]: {
            maxWidth: 400,
        },

        [mediaQueries.largePhoneOrSmaller]: {
            marginTop: 18,
            marginBottom: 80,
        },
    },
    content: {
        alignItems: "center",
        flexDirection: "row",

        [mediaQueries.smallDesktopOrSmaller]: {
            flexDirection: "column",
        },
    },
    imgContainer: {
        marginRight: 150,

        [mediaQueries.smallDesktopOrSmaller]: {
            marginRight: 0,
            marginBottom: 42,
        },

        [mediaQueries.largePhoneOrSmaller]: {
            marginBottom: 72,
        },
    },
    statList: {
        margin: "24px 0",
        [mediaQueries.smallDesktopOrSmaller]: {
            margin: "28px 0",
        },
    },
    stat: {
        display: "block",
        margin: "24px 0",

        [mediaQueries.smallDesktopOrSmaller]: {
            textAlign: "center",
            margin: "28px 0",
        },
    },
    // NOTE (russell): the styles below are actually used. The prop imageStyles
    // is required and accepts the value "bringEducation". These styles are
    // then applied via `styles[imageStyles]`. But the linter isn't seeing this
    // connection so I'm disabling it here. When additional value options are
    // added to imageStyles, they will also probbably need the linter disabled.
    // eslint-disable-next-line react-native/no-unused-styles
    bringEducation: {
        width: 369,

        [mediaQueries.smallDesktopOrSmaller]: {
            width: 204,
        },

        [mediaQueries.largePhoneOrSmaller]: {
            width: 224,
        },
    },
});
